<template>
  <div>
    <v-row>
      <v-col>
        <v-avatar class="avatar" :color="avatarCor" size="14rem" @click="disabled ? '' : abrirModal()">
          <img v-if="urlImagem" :src="urlImagem">
          <v-icon v-else dark class="d-flex justify-center" size="100">{{ icon }}</v-icon>
        </v-avatar>
      </v-col>
    </v-row>
    <v-dialog v-model="mostrarModal" persistent max-width="50rem">
      <v-card class="mx-auto">
        <v-toolbar flat outlined>
          <v-toolbar-title><v-icon :color="avatarCor" left size="x-large">mdi-camera-iris</v-icon>Adicionar
            Imagem</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="fecharModal()"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row v-if="$vuetify.breakpoint.smAndUp" class="d-flex flex-row justify-center align-center mx-2 my-2">
            <div class="button-container">
              <v-btn class="mr-2 mb-2 mt-2" :color="avatarCor">
                <v-icon>mdi-upload</v-icon>
                Carregar Imagem
              </v-btn>
              <input id="inputFile" type="file" accept="image/png, image/jpeg" class="inputfile"
                @input="alteraArquivoModal" />
              <v-btn class="mb-2 mt-2" :color="avatarCor" @click="checarWebcam">
                <v-icon>mdi-camera</v-icon>
                Iniciar Câmera
              </v-btn>
            </div>
          </v-row>
          <v-row v-else cols="12">
            <div class="button-container">
              <v-btn class="mb-2 mt-6" :color="avatarCor" width="100%">
                <div class="d-flex align-center">
                  <v-icon>mdi-upload</v-icon>
                </div>
                <div class="flex-grow-1 text-center">
                  Carregar Imagem
                </div>
              </v-btn>
              <input id="inputFile" type="file" accept="image/png, image/jpeg" class="inputfile"
                @change="alteraArquivoModal" />
              <v-btn class="mb-4" :color="avatarCor" width="100%" @click="checarWebcam">
                <div class="d-flex align-center">
                  <v-icon>mdi-camera</v-icon>
                </div>
                <div class="flex-grow-1 text-center">
                  Iniciar Câmera
                </div>
              </v-btn>
            </div>
          </v-row>
          <template v-if="arquivoModal !== '' && cameraAtiva === false">
            <div v-if="$vuetify.breakpoint.smAndUp" class="d-flex justify-center pb-4 pt-4">
              <v-avatar size="10rem" class="ml-3" :src="urlModal" v-if="!showCropper">
                <img :src="urlModal" />
              </v-avatar>
            </div>
            <div v-else>
              <div class="d-flex justify-center pb-4 pt-4">
                <v-avatar size="6rem" class="ml-3" :src="urlModal" v-if="!showCropper">
                  <img :src="urlModal" />
                </v-avatar>
              </div>
            </div>
            <template v-if="showCropper">
              <cropper ref="cropper" class="mb-2" :src="cropperImage" stencil-component="circle-stencil" :stencil-props="{
                handlers: {},
                movable: false,
                resizable: false,
              }" :stencil-size="{
                width: 400,
                height: 400
              }" image-restriction="stencil" />
              <div v-if="$vuetify.breakpoint.smAndUp" class="d-flex justify-center pb-4 pt-4">
                <v-btn @click="cropImage" :color="avatarCor">
                  <v-icon>mdi-crop</v-icon>
                  Recortar
                </v-btn>
              </div>
              <div v-else class="d-flex justify-center pb-4">
                <v-btn @click="cropImage" color="success" width="100%">
                  <v-icon>mdi-crop</v-icon>
                  Recortar
                </v-btn>
              </div>
            </template>
          </template>
          <template v-if="cameraAtiva">
            <div v-if="$vuetify.breakpoint.smAndUp" class="mt-4">
              <video v-show="!fotoTirada" ref="camera" :width="450" :height="337.5" autoplay></video>
              <div class="d-flex flex-row justify-center align-center">
                <v-btn class="mt-2 mb-4 mr-2" v-if="cameraAtiva" :color="avatarCor" @click="tirarFoto">
                  <v-icon>mdi-camera</v-icon>
                  Capturar Imagem
                </v-btn>
                <canvas v-show="false" id="photoTaken" ref="canvas" :width="450" :height="337.5"></canvas>
              </div>
            </div>
            <div v-else class="mb-4 mt-4">
              <video v-show="!fotoTirada" ref="camera" Width="100%" autoplay></video>
              <v-btn class="mt-2 mb-2" v-if="cameraAtiva" :color="avatarCor" width="100%" @click="tirarFoto">
                <div class="d-flex align-center">
                  <v-icon>mdi-camera</v-icon>
                </div>
                <div class="flex-grow-1 text-center">
                  Capturar Imagem
                </div>
              </v-btn>
              <canvas v-show="false" id="photoTaken" ref="canvas" :width="450" :height="337.5"></canvas>
            </div>
            <template v-if="fotoTirada && showCropper && !cameraAtiva">
              <cropper ref="cropper" :src="cropperImage" stencil-component="circle-stencil" :stencil-props="{
                handlers: {},
                movable: false,
                resizable: false,
              }" :stencil-size="{
                width: 280,
                height: 280
              }" image-restriction="stencil" />
              <div v-if="$vuetify.breakpoint.smAndUp" class="d-flex justify-center pb-4 pt-4">
                <v-btn @click="cropImage" :color="avatarCor">
                  <v-icon>mdi-crop</v-icon>
                  Recortar
                </v-btn>
              </div>
              <div v-else class="d-flex justify-center pb-4">
                <v-btn @click="cropImage" color="success" width="100%">
                  <v-icon>mdi-crop</v-icon>
                  Recortar
                </v-btn>
              </div>
            </template>
          </template>
          <v-divider></v-divider>
          <v-row class="d-flex flex-row justify-center align-center pt-2">
            <v-col v-if="$vuetify.breakpoint.smAndUp" cols="auto" class="d-flex">
              <v-btn color="warning" @click="apagaImagem" class="mr-2">
                <v-icon>mdi-image-off</v-icon>
                Sem Imagem
              </v-btn>
              <v-btn color="error" @click="cancelar" class="mr-2">
                <v-icon left>mdi-cancel</v-icon> Cancelar
              </v-btn>
              <v-btn :color="avatarCor" @click="salvar" :loading="carregando"
                :disabled="carregando || !(arquivoModal || urlModal) || showCropper">
                <v-icon left>$saveIcon</v-icon> Salvar
              </v-btn>
            </v-col>
            <v-col v-else cols="12">
              <v-btn color="warning" @click="apagaImagem" width="100%" class="mb-2">
                <div class="d-flex align-center">
                  <v-icon>mdi-image-off</v-icon>
                </div>
                <div class="flex-grow-1 text-center">
                  Sem Imagem
                </div>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="error" @click="cancelar" width="100%" class="mb-2">
                <div class="d-flex align-center">
                  <v-icon>mdi-close-circle-outline</v-icon>
                </div>
                <div class="flex-grow-1 text-center">
                  Cancelar
                </div>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn :color="avatarCor" @click="salvar" width="100%" class="mb-2" :loading="carregando"
                :disabled="carregando || !(arquivoModal || urlModal) || showCropper">
                <div class="d-flex align-center">
                  <v-icon>mdi-check-circle-outline</v-icon>
                </div>
                <div class="flex-grow-1 text-center">
                  Salvar
                </div>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { MensagemMixin } from '../../helpers/MensagemHelper';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import 'vue-advanced-cropper/dist/theme.bubble.css';
import { mapActions, mapGetters } from 'vuex';
import { ArquivoS3Service } from '@/services/ArquivoS3Service';
import { ObterArquivoType } from '@/types/arquivos/ObterArquivoType';

export default Vue.component('soi-avatar-input', {
  components: {
    Cropper,
  },
  data() {
    return {
      mostrarModal: false,
      carregando: false,
      cameraAtiva: false,
      fotoTirada: false,
      tirandoFoto: false,
      mostrarErroWebcam: false,
      arquivoModal: '',
      fotoModal: '',
      urlImagem: '',
      arquivo: '',
      urlModal: '',
      cropperImage: null,
      showCropper: false,
      arquivoS3Service: new ArquivoS3Service(),
    };
  },
  computed: {
    ...mapGetters('usuario', ['imagemUrl']),
    avatarCor() {
      const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--especialidade-primary').trim();
      return primaryColor || '#2e4b9d';
    },
  },
  props: {
    icon: {
      type: String,
      required: false,
      default: 'mdi-account',
    },
    value: {},
    fotoKey: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tipo: {
      type: String,
      default: 'paciente',
    },
    pacienteId: {
      type: [String, Number],
      required: false,
    },
    usuarioId: {
      type: String,
      required: false,
    },
    clinicaId: {
      type: [String, Number],
      required: false,
    },
  },
  watch: {
    fotoKey: {
      immediate: true,
      async handler(novoValor, valorAnterior) {
        if (!novoValor) {
          this.urlImagem = '';
          return;
        }

        if (novoValor.startsWith('http') || novoValor.startsWith('blob:') || novoValor.startsWith('data:')) {
          this.urlImagem = novoValor;
          return;
        }

        if (this.tipo === 'paciente' && !novoValor.includes('/')) {
          this.urlImagem = '';
          return;
        }

        if (valorAnterior && valorAnterior !== novoValor) {
          await this.aguardar(500);
        }

        let tipoParaUsar = this.tipo;

        if (!tipoParaUsar && novoValor) {
          if (novoValor.includes('/usuarios/') || novoValor.includes('medsystemcloud/')) {
            tipoParaUsar = 'usuario';
          } else if (novoValor.includes('/pacientes/')) {
            tipoParaUsar = 'paciente';
          } else if (novoValor.includes('/clinicas/')) {
            tipoParaUsar = 'clinica';
          } else if (novoValor.includes('/convenios/')) {
            tipoParaUsar = 'convenio';
          }
        }

        try {
          let response: any;

          if (tipoParaUsar === 'convenio') {
            try {
              response = await this.arquivoS3Service.ObterUrlImagemConvenio(novoValor);
            } catch {
              response = await this.arquivoS3Service.ObterUrlImagem(novoValor);
            }
          } else if (tipoParaUsar === 'clinica') {
            try {
              response = await this.arquivoS3Service.ObterUrlImagemClinica(novoValor);
            } catch {
              response = await this.arquivoS3Service.ObterUrlImagem(novoValor);
            }
          } else {
            response = await this.arquivoS3Service.ObterUrlImagem(novoValor);
          }

          const arquivo: ObterArquivoType = response.data ? response.data : response;
          this.urlImagem = arquivo?.caminhoArquivo || '';
        } catch (error) {
          if (tipoParaUsar === 'paciente') {
            console.warn('Não foi possível carregar a imagem do paciente:', novoValor);
            this.urlImagem = '';
            return;
          }

          if (tipoParaUsar === 'convenio' && (novoValor.includes('/usuarios/') || novoValor.includes('medsystemcloud/'))) {
            try {
              await this.aguardar(200);
              const responseException: any = await this.arquivoS3Service.ObterUrlImagem(novoValor);
              const arquivoException: ObterArquivoType = responseException.data ? responseException.data : responseException;
              this.urlImagem = arquivoException?.caminhoArquivo || '';
            } catch (fallbackError) {
              console.warn('Não foi possível carregar a imagem:', novoValor);
              this.urlImagem = '';
            }
          } else {
            try {
              await this.aguardar(1000);
              let retryResponse: any;

              if (tipoParaUsar === 'convenio') {
                try {
                  retryResponse = await this.arquivoS3Service.ObterUrlImagemConvenio(novoValor);
                } catch {
                  retryResponse = await this.arquivoS3Service.ObterUrlImagem(novoValor);
                }
              } else if (tipoParaUsar === 'clinica') {
                try {
                  retryResponse = await this.arquivoS3Service.ObterUrlImagemClinica(novoValor);
                } catch {
                  retryResponse = await this.arquivoS3Service.ObterUrlImagem(novoValor);
                }
              } else {
                retryResponse = await this.arquivoS3Service.ObterUrlImagem(novoValor);
              }

              const arquivoRetryResponse: ObterArquivoType = retryResponse.data ? retryResponse.data : retryResponse;
              this.urlImagem = arquivoRetryResponse?.caminhoArquivo || '';
            } catch (retryError) {
              if (tipoParaUsar !== 'paciente') {
                MensagemMixin(5000, 'warning', 'Não foi possível carregar a imagem. Tente novamente mais tarde.');
              }

              console.warn('Erro ao carregar imagem:', novoValor, retryError);
              this.urlImagem = '';
            }
          }
        }
      },
    },
  },
  mounted() {
  },
  methods: {
    ...mapActions('usuario', ['atualizarImagem']),
    aguardar(ms: number): Promise<void> {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async cropImage() {
      const result = this.$refs.cropper.getResult();
      this.urlModal = result.canvas.toDataURL('image/png');

      this.arquivoModal = await new Promise((resolve) => {
        result.canvas.toBlob((blob: any) => {
          resolve(new File([blob], 'avatar.png', { type: 'image/png' }));
        }, 'image/png', 0.9);
      });

      this.showCropper = false;
    },
    async apagaImagem() {
      const inputFile = document.getElementById('inputFile') as HTMLInputElement;
      inputFile.value = '';
      this.fecharModal();
      this.cropperImage = '';
      this.urlImagem = '';
      this.urlModal = '';
      this.arquivo = '';
      this.arquivoModal = '';
      this.$emit('input', this.arquivo);
      this.atualizarImagem('');
      this.$emit('update:fotoKey', this.urlImagem);
      this.$emit('apagarFoto');
      this.pararCamera();
      await this.arquivoS3Service.ExcluirImagemUsuario(this.usuarioId, this.fotoKey);
    },
    async alteraArquivoModal(e: any) {
      const novoArquivo = await e.target.files[0];
      this.arquivoModal = novoArquivo;
      this.urlModal = URL.createObjectURL(this.arquivoModal);
      this.cropperImage = this.urlModal;
      this.showCropper = true;
      this.pararCamera();
    },
    async checarWebcam() {
      try {
        await navigator.mediaDevices.getUserMedia({ video: true });
        this.iniciarCamera();
      } catch (error) {
        MensagemMixin(5000, 'warning', 'Não há nenhum dispositivo de captura de imagens disponível no momento.');
        this.mostrarErroWebcam = true;
      }
    },
    async iniciarCamera() {
      this.cameraAtiva = true;

      const constraints: MediaStreamConstraints = {
        audio: false,
        video: true,
      };

      try {
        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        this.$refs.camera.srcObject = stream;
      } catch (error) {
        this.cameraAtiva = false;
      }
    },
    pararCamera() {
      if (this.cameraAtiva) {
        const tracks = this.$refs.camera.srcObject.getTracks();
        tracks.forEach((track: { stop: () => void; }) => {
          track.stop();
        });
      }
      this.cameraAtiva = false;
    },
    async tirarFoto() {
      const FLASH_TIMEOUT = 50;
      await new Promise((resolve) => { setTimeout(resolve, FLASH_TIMEOUT); });
      const context = this.$refs.canvas.getContext('2d');
      context.drawImage(this.$refs.camera, 0, 0, 450, 337.5);
      this.urlModal = this.$refs.canvas.toDataURL('image/png');

      this.arquivoModal = await new Promise((resolve) => {
        this.$refs.canvas.toBlob((blob: any) => {
          resolve(new File([blob], 'avatar.png', { type: 'image/png' }));
        }, 'image/png', 0.9);
      });

      this.cropperImage = this.urlModal;
      this.pararCamera();
      this.fotoTirada = true;
      this.showCropper = true;
    },
    async salvar() {
      this.pararCamera();

      if (!this.arquivoModal) {
        MensagemMixin(3000, 'error', 'Erro ao processar a imagem. Por favor, tente novamente.');
        return;
      }

      this.arquivo = this.arquivoModal;
      this.urlImagem = this.urlModal;

      if (this.tipo === 'usuario' || this.tipo === 'paciente') {
        this.$emit('input', this.arquivo);
        this.$emit('update:fotoKey', this.urlModal);
      } else if (this.tipo === 'clinica') {
        const atualizacaoImagem = await this.arquivoS3Service.AtualizarImagemClinica(
          this.clinicaId,
          this.fotoKey,
          this.arquivo,
        );

        if (atualizacaoImagem && atualizacaoImagem.caminhoArquivo) {
          this.$emit('update:fotoKey', atualizacaoImagem.caminhoArquivo);
        }

        this.$emit('input', this.arquivo);
        this.fecharModal();
        return;
      }

      this.$emit('input', this.arquivo);
      this.fecharModal();
    },
    cancelar() {
      const inputFile = document.getElementById('inputFile') as HTMLInputElement;
      inputFile.value = '';
      this.pararCamera();
      this.fecharModal();
      this.showCropper = false;
    },
    abrirModal() {
      this.urlModal = '';
      this.arquivoModal = '';
      this.mostrarModal = true;
    },
    fecharModal() {
      this.mostrarModal = false;
      this.pararCamera();
    },
  },
});
</script>
<style scoped>
.video {
  overflow: hidden;
}

.avatar:hover {
  cursor: pointer;
  transition: 300ms;
  transform: scale(1.01);
  border: solid 1px var(--especialidade-primary, #2e4b9d);
  box-shadow: 0 0 0.2em var(--especialidade-primary, rgb(137, 137, 137));
}

.button-container {
  position: relative;
  display: inline-block;
  border-radius: 10px;
}

.button-container input[type="file"] {
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: pointer;
  top: 0;
  right: 0;
  opacity: 0;
}

.imagem {
  width: 100%;
  height: auto;
  max-height: 300px;
  max-width: 300px;
}

.v-avatar {
  display: flow-root !important;
}
</style>
